import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';

const ShareSection = () => {
  // Use the current window URL for sharing
  const shareUrl = encodeURIComponent(window.location.href);
  const shareTitle = encodeURIComponent("Check out PEI Commuters - Your one-stop dashboard for PEI weather and road conditions!");

  const shareLinks = [
    {
      name: 'Facebook',
      icon: 'Facebook',
      color: 'bg-[#1877F2]',
      url: `https://www.facebook.com/sharer/sharer.php?u=${shareUrl}`
    },
    {
      name: 'X (Twitter)',
      icon: 'Twitter',
      color: 'bg-[#000000]',
      url: `https://twitter.com/intent/tweet?url=${shareUrl}&text=${shareTitle}`
    },
    {
      name: 'LinkedIn',
      icon: 'Linkedin',
      color: 'bg-[#0A66C2]',
      url: `https://www.linkedin.com/sharing/share-offsite/?url=${shareUrl}`
    },
    {
      name: 'WhatsApp',
      icon: 'MessageCircle',
      color: 'bg-[#25D366]',
      url: `https://wa.me/?text=${shareTitle}%20${shareUrl}`
    },
    {
      name: 'Email',
      icon: 'Mail',
      color: 'bg-slate-600',
      url: `mailto:?subject=${shareTitle}&body=I thought you might find this useful: ${shareUrl}`
    }
  ];

  return (
    <div className="mt-16 pb-12">
      <div className="text-center mb-8">
        <div className="inline-block px-4 py-1 bg-slate-200 rounded-full mb-3">
          <p className="text-[10px] font-black text-slate-500 uppercase tracking-[0.3em]">Spread the word</p>
        </div>
        <h3 className="text-2xl font-black text-slate-900 uppercase tracking-tighter">Share this page</h3>
      </div>
      
      <div className="flex flex-wrap justify-center gap-4">
        {shareLinks.map((link) => (
          <motion.a
            key={link.name}
            href={link.url}
            target="_blank"
            rel="noopener noreferrer"
            whileHover={{ scale: 1.1, y: -4 }}
            whileTap={{ scale: 0.9 }}
            className={`${link.color} w-14 h-14 rounded-2xl shadow-xl text-white flex items-center justify-center transition-all hover:shadow-2xl`}
            title={`Share on ${link.name}`}
          >
            <SafeIcon name={link.icon} className="text-2xl" />
          </motion.a>
        ))}
      </div>
    </div>
  );
};

export default ShareSection;